<p>cal-rating-manager works!</p>
